import Page from 'lib/components/Page'
import SEO from 'lib/components/SEO'
import Vehicle from 'lib/components/Vehicle'
import { AuthProvider, useAuth } from 'lib/context/AuthContext'

import DeliveryPreference from './DeliveryPreference'
import NotificationSettings from './NotificationSettings'
import Messages from './Messages'
import Plan from './Plan'

const User = () => {
  const [user] = useAuth()

  return (
    <>
      <SEO
        title="Your Account | Recall Monitor"
        description="Manage your account settings for Recall Monitor."
        canonical="https://recallmonitor.ca/user"
      />
      <Page
        header="User Settings"
        subheader="Changes are saved instantly"
        preHeader={
          <>
            <Messages />
          </>
        }
      >
        <Plan />

        <DeliveryPreference />

        <Vehicle user={user} />

        <NotificationSettings />
      </Page>
    </>
  )
}

export default function UserWrap() {
  return (
    <AuthProvider>
      <User />
    </AuthProvider>
  )
}
